import { InfoOutlined } from "@mui/icons-material";
import {
  Stack,
  StackProps,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";

import { TExportContactsOption } from "../../types.ts";

type TExportContentProps = StackProps & {
  contactsCount?: null | number;
  infoElement?: ReactNode;
  option: TExportContactsOption;
};

const ExportContent = ({
  children,
  contactsCount,
  infoElement,
  option,
  ...rest
}: TExportContentProps) => {
  const { additionalContent, content, tooltip } = option;

  return (
    <Stack {...rest}>
      <Stack alignItems="center" direction="row" gap="4px">
        {content && (
          <Typography
            dangerouslySetInnerHTML={{ __html: content }}
            sx={styles.description}
          />
        )}
        {infoElement}
        {tooltip && (
              <Tooltip
                arrow
                placement="bottom"
                slotProps={{
                  popper: {
                    sx: styles.infoTooltip,
                  },
                }}
                title={
                  <Stack gap="4px">
                    <Typography fontSize="14px">Information</Typography>
                    <Typography fontSize="12px" lineHeight="20px">
                      {tooltip}
                    </Typography>
                  </Stack>
                }
              >
                <InfoOutlined
                  sx={styles.infoIcon}
                />
              </Tooltip>
        )}
      </Stack>
      {additionalContent && (
        <Typography sx={styles.additionalContent}>
          {additionalContent}
        </Typography>
      )}
      <Stack mt="16px">{children}</Stack>
      {typeof contactsCount === "number" && (
        <Typography sx={styles.contacts}>
          <span>{contactsCount}</span>Contacts found
        </Typography>
      )}
    </Stack>
  );
};

const styles = {
  additionalContent: {
    color: "var(--text-grey)",
    fontSize: "12px",
    lineHeight: 1.5,
    marginTop: "8px",
  },
  contacts: {
    "& > span": {
      color: "var(--black)",
      fontSize: "18px",
    },
    alignItems: "center",
    color: "var(--text-grey)",
    display: "inline-flex",
    fontSize: "12px",
    fontWeight: 600,
    gap: "4px",
    lineHeight: 1.5,
    marginTop: "8px",
  },
  description: {
    color: "var(--text-grey)",
    fontSize: "14px",
    lineHeight: 1.28,
  },
  infoIcon: {
    color: "var(--primary-text)",
    cursor: "pointer",
    fontSize: "16px",
  },
  infoTooltip: {
    [`& .${tooltipClasses.arrow}`]: {
      color: "var(--text-grey)",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "var(--text-grey)",
      borderRadius: "10px",
      maxWidth: "510px",
      padding: "20px",
      width: "100%",
    },
  },
};

export default ExportContent;
